import { render, staticRenderFns } from "./OffCanvasKayttaja.vue?vue&type=template&id=65f6219c&scoped=true&"
import script from "./OffCanvasKayttaja.vue?vue&type=script&lang=js&"
export * from "./OffCanvasKayttaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6219c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f6219c')) {
      api.createRecord('65f6219c', component.options)
    } else {
      api.reload('65f6219c', component.options)
    }
    module.hot.accept("./OffCanvasKayttaja.vue?vue&type=template&id=65f6219c&scoped=true&", function () {
      api.rerender('65f6219c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasKayttaja.vue"
export default component.exports